/* eslint-disable camelcase */
import { DogItemInfos } from '@assets/rex/items/types/dog.item.info';

const infos: DogItemInfos = {};

export default infos;
